export default "__VITE_ASSET__CW6k$e$D__"